import AssetImage from './AssetImage';

export default AssetImage;
